import { render, staticRenderFns } from "./ModalVistaPreviaCrucigrama.vue?vue&type=template&id=459c0d6a&scoped=true&"
import script from "./ModalVistaPreviaCrucigrama.vue?vue&type=script&lang=js&"
export * from "./ModalVistaPreviaCrucigrama.vue?vue&type=script&lang=js&"
import style0 from "./ModalVistaPreviaCrucigrama.vue?vue&type=style&index=0&id=459c0d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c0d6a",
  null
  
)

export default component.exports